import type { Meeting } from '@tebuto/api/therapists/models/Meeting'
import type { MeetingList } from '@tebuto/api/therapists/models/MeetingList'

export const MEETINGS_PAGE_SIZE = 100
const MAX_MEETING_PAGES = 50

export async function fetchMeetingsInRange(
    loadPage: (page: number, pageSize: number) => PromiseLike<MeetingList>
): Promise<MeetingList> {
    const meetings: Meeting[] = []
    let page = 1
    let total = 0

    while (page <= MAX_MEETING_PAGES) {
        const list = await loadPage(page, MEETINGS_PAGE_SIZE)
        total = list.total
        meetings.push(...list.meetings)
        if (list.meetings.length === 0 || meetings.length >= list.total) {
            break
        }
        page += 1
    }

    return { meetings, total }
}
